import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalActions, Form } from '@contently/toolkit';
import * as actions from '../../store/actions/index';

export const ConfirmationModal = props => {
  const { isOpen, fromUser, toUser, onCancel, onConfirm, disableConfirmation } = props;

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <ModalHeader>Are you sure?</ModalHeader>
      <ModalBody>
        {'You’re about to reassign all of '}
        <strong>{fromUser}</strong>
        {'’s workflow steps to '}
        <strong>{toUser}</strong>
        {' for stories still in progress. Click the button below to confirm.'}
      </ModalBody>
      <ModalActions>
        <Form.Button onClick={onCancel}>Cancel</Form.Button>
        <Form.ButtonWithProgress
          disabled={disableConfirmation}
          onClick={onConfirm}
          variant="primary"
        >
          Confirm
        </Form.ButtonWithProgress>
      </ModalActions>
    </Modal>
  );
};

ConfirmationModal.defaultProps = {
  fromUser: null,
  toUser: null
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  fromUser: PropTypes.string,
  toUser: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disableConfirmation: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isOpen: state.reassignUsers.confirmModalOpen,
  disableConfirmation: state.reassignUsers.reassignmentInProgress
});

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(actions.toggleConfirmModal())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModal);



// WEBPACK FOOTER //
// ./app/javascript/app/components/reassign_users/confirmation_modal.jsx